import { all } from 'redux-saga/effects';

import { getCartSagaWatcher } from './get_cart.saga'
import { addToCartSagaWatcher } from './add_to_cart.saga'
import { removeFromCartSagaWatcher } from './remove_from_cart.saga'
import { emptyCartSagaWatcher } from './empty_cart.saga'
import { submitCartSagaWatcher } from './submit_cart.saga'
import { increaseCartCountSagaWatcher } from './increase_cart_count.saga'
import { decreaseCartCountSagaWatcher} from './decrease_cart_count.saga'
import { mergeCartSagaWatcher} from './merge_cart.saga'
import { repeatOrderSagaWatcher } from './repeat_order.saga'


export default function* cartSaga() {
    yield all([
        getCartSagaWatcher(),
        addToCartSagaWatcher(),
        removeFromCartSagaWatcher(),
        emptyCartSagaWatcher(),
        submitCartSagaWatcher(),
        increaseCartCountSagaWatcher(),
        decreaseCartCountSagaWatcher(),
        mergeCartSagaWatcher(),
        repeatOrderSagaWatcher()
    ]);
}